<template>
  <!-- 查看合同页面 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="我的合同" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierInfo" slot="left">
        <yd-navbar-back-icon>个人中心</yd-navbar-back-icon>
      </router-link>
      <div slot="right" style="display: none" >
        <yd-button  @click.native="addContract()" bgcolor="#2f6fff" color="#fff" shape="circle" style="position: absolute;top: 12px; right: 15px;">添加合同</yd-button>
      </div>
    </yd-navbar>
    <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in contractList" :key="index">
      <yd-preview-header style="margin-top:5px;">
        <div slot="left" style="text-align: left;font-weight:bolder;">合同编号：</div>
        <div slot="right" style="position: absolute;right: 0px;">{{item.contract_no}}
        </div>
      </yd-preview-header>
<!--      <yd-preview-item>-->
<!--        <div slot="left">合同名称</div>-->
<!--        <div slot="right">{{item.contract_name}}</div>-->
<!--      </yd-preview-item>-->
      <yd-preview-item>
        <div slot="left">供应商编码</div>
        <div slot="right">{{item.supplier_no}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">供应商名称</div>
        <div slot="right">{{item.supplier_name}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">报审序号</div>
        <div slot="right">{{item.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">签订时间</div>
        <div slot="right">{{item.order_date}}</div>
      </yd-preview-item>
    </yd-preview>
    <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="contractList.length==0">暂无新增合同信息</yd-preview>
  </div>
</template>
<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
    data() {
        return {
            btns:[],
            userId:window.localStorage.getItem("checkUserId"),
            contractList: []
        }
    },
    methods: {
      addContract() {
        this.$dialog.confirm({
          title: '提示',
          mes: '仅需添加当天新办理的合同，按照合同签约审查审批表信息录入！',
          opts: [
            {
              txt: '取消',
              color: false,
              callback: () => {}
            },
            {
              txt: '确定',
              color: true,
              callback: () => {
                this.$router.push({ path: "/supplierAdd",query:{supplierUser:this.supplierUser} });
              }
            }
          ]
        });
      },
      //加载可预约合同资源
      getContractList(userId){
        axios({
            method: "get",
            url: baseUrl + "myContract?userId="+this.userId
          }).then(resp => {
            if (resp.data.error_code == "0") {
              this.contractList = resp.data.data
            }
            })
      }
    },
  mounted() {
   if(!this.userId){
      this.$router.push({ path: "/login"});
   }
   this.getContractList();

  }
}
</script>

<style scoped>
.yd-preview-header > :last-child {
  font-size: 0.28rem;
  margin-right: 0.2rem;
}
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-mycontract.vue